import _ from 'lodash'
import COMPONENT from 'src/api/dev/component'
import * as T from './types'

const module = {
    state: {
        currentItem: {},
        branchTagInfo: {},
        versionList: [],
        componentList: [],
        total: 0,
        versionTotal: 0,
        packageList: [],
        packageTotal: 0
    },

    mutations: {
        [T.SET_COMPONENT_LIST](state, { items, total }) {
            state.componentList = items.map(item => {
                const newResult = {}
                // 字段转驼峰
                Object.keys(item).forEach(key => {
                    newResult[_.camelCase(key)] = item[key]
                })
                return newResult
            })
            state.total = total
        },
        [T.SET_COMPONENT_DETAIL](state, res) {
            state.currentItem = res
        },
        [T.UPDATE_COMPONENT_ITEM](state, item) {
            // 如果API成功，更新vuex中的数据。使用解构的方式创建新的obj
            const d = new Date()
            /*eslint no-mixed-operators: "off"*/
            item.modifiedOn = new Date(+d - d.getTimezoneOffset() * 60 * 1000)
                .toISOString()
                .replace('T', ' ')
                .substr(0, 19)
            state.currentItem = item
            const index = state.componentList.findIndex(({ id }) => id === item.id)
            if (index > -1) {
                state.componentList[index] = Object.assign(state.componentList[index], item)
            }
        },
        [T.SET_VERSION_LIST](state, { items = [], total = 0 }) {
            state.versionList = items
            state.versionTotal = total
        },
        [T.DELETE_VERSION](state, id) {
            state.versionList = state.versionList.filter(item => item.id !== id)
            state.versionTotal -= 1
        },
        [T.SET_BRANCH_TAG_INFO](state, { gitUrl, ...info }) {
            state.branchTagInfo = { gitUrl, ...info }
        },
        [T.SET_PACKAGE_LIST](state, payload) {
            const { items = [], total = 0 } = payload
            state.packageList = items
            state.packageTotal = total
        }
    },

    actions: {
        async getComponentList({ commit }, params) {
            commit(T.SET_COMPONENT_LIST, await COMPONENT.list(params))
        },
        async getComponentDetail({ commit }, id) {
            const res = await COMPONENT.detail(id)
            // 字段转驼峰
            const item = Object.keys(res).reduce((result, key) => {
                result[_.camelCase(key)] = res[key]
                return result
            }, {})
            commit(T.SET_COMPONENT_DETAIL, item)
        },
        async updateCurrentItem({ commit, rootState }, params) {
            params.groupName = ({
                
                ...rootState.group.groupList.find(item => item.id === params.groupId)
            }).name
            await COMPONENT.update(params)
            commit(T.UPDATE_COMPONENT_ITEM, params)
        },
        async getVersionList({ commit }, params) {
            commit(T.SET_VERSION_LIST, await COMPONENT.versionList(params))
        },
        async deleteVersion({ commit }, id) {
            await COMPONENT.deleteVersion(id)
            commit(T.DELETE_VERSION, id)
        },
        async loadBranchTagInfo({ commit }, gitUrl) {
            // 【ID1033315】每次选择分支或标签都重新获取数据
            // if (state.branchTagInfo.gitUrl === gitUrl) return

            const { branches: rawBranches, tags: rawTags } = await COMPONENT.getBranchAndTagList(
                gitUrl
            )
            const branches = rawBranches.map(item => ({
                value: item,
                type: 'branch'
            }))
            const tags = rawTags.map(item => ({
                value: item,
                type: 'tag'
            }))
            commit(T.SET_BRANCH_TAG_INFO, {
                branches,
                tags,
                gitUrl
            })
        },

        // 组件包
        getPackageList({ commit }, payload) {
            return COMPONENT.getPackageList(payload).then(res => {
                commit(T.SET_PACKAGE_LIST, res)
                return res
            })
        },
        deletePackage(store, payload) {
            return COMPONENT.deletePackage(payload)
        },
        addPackage(store, payload) {
            return COMPONENT.addPackage(payload)
        },
        addPackageFromGit(store, payload) {
            return COMPONENT.addPackageFromGit(payload)
        },
        retryPackageFromGit(store, payload) {
            return COMPONENT.retryPackageFromGit(payload)
        },
        refreshPackage(store, payload) {
            return COMPONENT.refreshPackage(payload)
        },
        addPackageVersion(store, payload) {
            return COMPONENT.addPackageVersion(payload)
        },
        addPackageVersionFromGit(store, payload) {
            return COMPONENT.addPackageVersionFromGit(payload)
        },
        getPackageVersion(store, payload) {
            return COMPONENT.getPackageVersion(payload)
        },
        deletePackageVersion(store, payload) {
            return COMPONENT.deletePackageVersion(payload)
        },
        getPackageDetail(store, payload) {
            return COMPONENT.getPackageDetail(payload)
        },
        getPackageLatestVersion(store, payload) {
            return COMPONENT.getPackageLatestVersion(payload)
        },
        getPackageVersionLogs(store, payload) {
            return COMPONENT.getPackageVersionLogs(payload)
        },
        getComponentDepsList(store, payload) {
            return COMPONENT.getComponentDepsList(payload.componentVersionId, {
                type: payload.type
            })
        },
        saveComponentDeps(store, payload) {
            return COMPONENT.saveComponentDeps(payload)
        },
        saveComponentEngineScope(store, payload) {
            return COMPONENT.saveComponentEngineScope(payload)
        }
    }
}

export default module
